import { ErrorConverterService } from '../services/error-converter.service';
import { ReportableError } from '../services/app-error';
import { ErrorPacket, Next } from './types';

export function createErrorTerminal(
    errorConverter: ErrorConverterService,
): Next<ErrorPacket, ErrorPacket> {
    return (packet: ErrorPacket): ErrorPacket => {
        if (!packet.result) {
            console.warn(
                '[ErrorTerminal] No pipe handled this error. Using fallback:',
                packet.data,
            );

            return {
                ...packet,
                result: errorConverter.getAppErrorFromError(packet.data as ReportableError),
            };
        }

        return packet;
    };
}
